// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bqq5","field":"styles_field__1M7T-","fieldCol":"styles_fieldCol__1AJ0c","diffCol":"styles_diffCol__2EcOv","diff":"styles_diff__3TNAT"};